import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import { AuthProvider, useAuth } from './context/AuthContext';
import AdminLayout from './components/AdminLayout';
import AdminLogin from './pages/AdminLogin';
import ScratchCardsPage from './pages/ScratchCardsPage';
import ProductCodesPage from './pages/ProductCodesPage';
import DashboardPage from './pages/DashboardPage';
import CustomerLayout from './components/CustomerLayout';
import ProductVerificationPage from './pages/ProductVerificationPage';
import LoyaltyProgramPage from './pages/LoyaltyProgramPage';
import AuthPage from './pages/AuthPage';
import ScratchCardRedemptionPage from './pages/ScratchCardRedemptionPage';
import LandingPage from './pages/LandingPage';

// Create theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const { admin, loading } = useAuth();

  console.log('ProtectedRoute - admin:', admin, 'loading:', loading);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!admin) {
    console.log('No admin found, redirecting to login');
    return <Navigate to="/admin/login" />;
  }

  console.log('Admin found, rendering children');
  return children;
};

const AdminRoute = ({ children }) => {
  return (
    <ProtectedRoute>
      <AdminLayout>{children}</AdminLayout>
    </ProtectedRoute>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            
            {/* Protected admin routes */}
            <Route
              path="/admin/dashboard"
              element={
                <AdminRoute>
                  <DashboardPage />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/product-codes"
              element={
                <AdminRoute>
                  <ProductCodesPage />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/scratch-cards"
              element={
                <AdminRoute>
                  <ScratchCardsPage />
                </AdminRoute>
              }
            />

            {/* Redirect to dashboard if logged in, otherwise to login page */}
            <Route
              path="/admin"
              element={<Navigate to="/admin/dashboard" replace />}
            />
            
            {/* Landing page */}
            <Route path="" element={
                <CustomerLayout>
                  <LandingPage />
                </CustomerLayout>
              } />
            
            {/* Customer routes */}
            <Route
              path="/"
              element={
                <CustomerLayout>
                  <LandingPage />
                </CustomerLayout>
              }
            />
            <Route
              path="/verify"
              element={
                <CustomerLayout>
                  <ProductVerificationPage />
                </CustomerLayout>
              }
            />
            <Route
              path="/loyalty"
              element={
                // <CustomerLayout>
                  <LoyaltyProgramPage />
                // </CustomerLayout>
              }
            />
            <Route
              path="/redeem"
              element={
                <CustomerLayout>
                  <ScratchCardRedemptionPage />
                </CustomerLayout>
              }
            />
            <Route
              path="/auth"
              element={
                <CustomerLayout>
                  <AuthPage />
                </CustomerLayout>
              }
            />
            <Route
              path="/signup"
              element={
                <CustomerLayout>
                  <AuthPage />
                </CustomerLayout>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
